(function () {
    "use strict";
    angular.module("virtualFairs")
        .controller(
            "virtualFairHelpUsHelpYouController",
            virtualFairHelpUsHelpYouController
        );
    virtualFairHelpUsHelpYouController.$inject = ["VirtualFairService", "$state"];
    function virtualFairHelpUsHelpYouController(VirtualFairService, $state) {
        let vm = this;

        vm.virtualfairSelected = {};
        vm.virtualfairList = [];
        vm.questionsList = [];
        vm.getVirtualFairByEvent = getVirtualFairByEvent;
        vm.getQuestions = getQuestions;
        vm.getCsv = getCsv;
        vm.convertToTrueOrFalse = convertToTrueOrFalse;

        async function getVirtualFairByEvent () {
            await VirtualFairService.getVirtualFairByEvent().then(function(response){
                vm.virtualfairList = response.data;
            })
        }

        async function getQuestions() {
            let expoVirtualFairId = vm.virtualfairSelected;
            await VirtualFairService.getQuestions(expoVirtualFairId).then(function(response){
                vm.questionsList = response.data;
            })
        }

        function getCsv() {
            let expoVirtualFairId = vm.virtualfairSelected;
            VirtualFairService.getQuestionsCsv(expoVirtualFairId).success(function(response) {
                let anchor = document.createElement("a");
                anchor.href = "data:application/octet-stream;base64," + encodeURI(response);
                anchor.target = "_blank";
                anchor.download = `help_us_help_you.csv`;
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }

        function convertToTrueOrFalse(item) {
            if (item === 1) {
                return 'Yes';
            }
            return 'No';
        }
        async function activate() { 
            await vm.getVirtualFairByEvent();
        }

        activate();
    }
})();
